module.exports = __webpack_public_path__ + "static/media/menu-icon.0c9fcc8e.svg";